export class SubscriptionHistory {
  currentSubscription!: CurrentSubscription
  expiredSubscriptions!: any[]
}

export class CurrentSubscription {
  planTiltleName!: number
  amount!: number
  startedOn!: string
  validTo!: string
  status!: number
}
